// Our Utils
import { dataIsValid } from 'shared/utils';

function selectHighlightCardData(data) {
	const isDataPresent = dataIsValid(data);

	return isDataPresent ? data.totalLoans : 0;
}

export default selectHighlightCardData;
